import * as userType from './usersTypes';
import cloneDeep from 'lodash.clonedeep';

const initialState = {
  countryList: [],
  userDetail: {
    mode: 'Close',
    profileKey: '',
    firstName: '',
    lastName: '',
    email: '',
    roles: [],
    engagements: [],
    updatedAt: new Date().getTime(),
    availabilityDetails: {},
  },
  systemRoles: [],
  engagementsList: [],
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case userType.INIT_USERS_LIST: {
      return { ...state, users: [] };
    }

    case userType.GET_USERS_SUCCESS: {
      return { ...state, users: action.users };
    }

    case userType.GET_USERS_ENGAGEMENT_OPTIONS_SUCCESS: {
      return { ...state, engagementOptions: action.engagementOptions };
    }
    case userType.RESET_USERDETAIL_OBJECT: {
      return {
        ...state,
        userDetail: {
          profileKey: '',
          firstName: '',
          lastName: '',
          email: '',
          roles: [],
          engagements: [],
          updatedAt: new Date().getTime(),
          availabilityDetails: {},
        },
        originalEngagementList: [],
      };
    }
    case userType.USERDETAIL_FORM_ATTR: {
      return { ...state, userDetail: { ...state.userDetail, [action.field]: action.data } };
    }
    case userType.SET_USERDETAIL_OBJECT: {
      return { ...state, userDetail: cloneDeep(action.data), originalEngagementList: action.data.engagements };
    }
    case userType.SET_USERS_DETAIL_ENGAGEMENTS: {
      return { ...state, userDetail: { ...state.userDetail, engagements: action.engagements } };
    }
    case userType.GET_COUNTRYLIST_SUCCESS:
      return { ...state, countryList: action.data };

    case userType.SET_SYSTEM_ROLES:
      return { ...state, systemRoles: action.data };

    default:
      return state;
  }
};

export { initialState };
export default usersReducer;



// WEBPACK FOOTER //
// ./src/ui/features/Users/state/usersReducer.js